<template>
  <header class="search header">
    <div class="header__container tw-bg-white">
      <div class="header__drawer-menu tw-absolute">
        <slot name="drawer-menu"></slot>
      </div>
      <div
        class="header__title"
        data-testid="header-bar-title"
      >
        <slot name="header-title">ACV Transportation Load Board</slot>
      </div>
      <nav class="header__left-column tw-hidden tw-md:tw-flex">
        <NuxtLink to="/">
          <span>
            <SvgTransportLogo
              class="acv-logo"
              alt="The logo of ACV Auctions"
            />
          </span>
        </NuxtLink>
        <div class="header__links">
          <slot>
            <HeaderNav :routes="routes" />
          </slot>
        </div>
      </nav>
      <div class="header__right-column tw-hidden tw-md:tw-flex">
        <DropdownMenu />
      </div>
    </div>
  </header>
</template>

<script setup>
import { useStagedJobsStore } from '@/stores/useStagedJobs';
import useIsUserManageOnly from '@/composables/useIsUserManageOnly';

const stagedJobsStore = useStagedJobsStore();
const { isUserManageOnly } = useIsUserManageOnly();

const routes = computed(() => {
  if (isUserManageOnly) {
    return [
      {
        path: '/manage-jobs/active',
        name: 'Manage',
        testid: 'header-manage',
      },
    ];
  }
  return [
    {
      path: '/',
      name: 'Job List',
      testid: 'header-joblist',
    },
    {
      path: '/staged',
      name: 'Staged',
      badge: stagedJobsStore?.pagination?.totalElements || null,
      testid: 'header-staged',
    },
    {
      path: '/manage-jobs/active',
      name: 'Manage',
      testid: 'header-manage',
    },
  ];
});
</script>

<style lang="scss" scoped>
@use '@/assets/scss/fonts.scss';
@use '@/assets/scss/badge.scss';

// mobile
.header__title {
  @apply tw-bg-grey-light-x tw-px-6 tw-py-3 tw-text-center tw-text-xl tw-font-medium tw-text-text-secondary tw-md:tw-hidden;

  border-bottom: 1px solid theme('colors.border.base');
}
// desktop
.header {
  @screen tw-md {
    @apply tw-bg-white;

    .header__container {
      @apply tw-flex tw-flex-row tw-items-center tw-justify-between;
      padding: 0 30px;

      .header__drawer-menu {
        @apply tw-hidden;
      }

      .header__left-column {
        @apply tw-flex tw-flex-row tw-content-center tw-justify-between;

        .header__links {
          @apply tw-m-auto tw-hidden tw-h-full tw-whitespace-nowrap tw-md:tw-flex tw-md:tw-pl-8;
        }

        .acv-logo {
          height: 31px;
          margin: 0.75rem 0;
        }

        .nav-badge {
          @apply tw-relative tw-bottom-0.5 tw-rounded-sm tw-bg-primary-base tw-text-white;

          font-size: 12px;
          padding: 3px;
          margin-left: 6px;
        }
      }

      .header__right-column {
        @apply tw-relative tw-flex tw-flex-row tw-items-center tw-justify-between;

        .search-notifications-menu {
          margin-right: 0.25rem;

          :deep(.notification-badge) {
            @apply tw-p-1;

            top: 0.2rem;
          }

          &.is-search :deep(.notification-badge) {
            top: 0.75rem;
            right: 0.75rem;
          }

          :deep(#notificationsMenu) {
            .btn {
              border-radius: 30px;
              width: 44px;
              height: 44px;
              padding: 0.375rem 0.75rem;

              svg {
                color: theme('colors.black.500');
              }

              &:hover {
                background-color: rgba(0, 0, 0, 0.1);

                svg {
                  color: theme('colors.black.500');
                }
              }
            }

            .dropdown-header {
              @apply tw-border-0;

              .col {
                @apply tw-leading-6;

                h6 {
                  @apply tw-text-xl tw-font-medium;
                }
              }
            }

            .notifications-item {
              @apply tw-border-b-0;
            }

            .dropdown-menu {
              margin-top: 5px;

              .view-all-btn {
                a {
                  &.dropdown-item {
                    @apply tw-border-0 tw-bg-transparent;
                  }
                }

                &:hover {
                  text-decoration: underline;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
